import jQuery from "jquery";

/**
 * Modifications to content in article detail view
 *
 * @export
 */
export default function() {
  const $ = jQuery;

  $("a.mg-detail__full-link").each(function() {
    $(this).attr("href", location.pathname.replace(/\/summary\//g, "/full/"));
  });

  // sharing / utility icons
  var facebookShareUrl =
      "https://facebook.com/sharer/sharer.php?u=" + location.href,
    $facebookShareIcon = $(
      '<a class="resp-sharing-button__link" href="' +
        facebookShareUrl +
        '" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg></div></div></a>'
    ),
    $twitterShareIcon = $(
      '<a class="resp-sharing-button__link" href="https://twitter.com/intent/tweet/?text=' +
        document.title +
        "&url=" +
        location.href +
        '" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></div></div></a>'
    ),
    $emailIcon = $(
      '<a class="resp-sharing-button__link" href="mailto:?subject=' +
        document.title +
        "&body=" +
        location.href +
        '" target="_self" aria-label=""><div class="resp-sharing-button resp-sharing-button--email resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"/></svg></div></div></a>'
    ),
    $shareIcons = $facebookShareIcon.add($twitterShareIcon).add($emailIcon);

  $(".mg-detail__utility").prepend(
    '<small class="sharing__label">SHARE</small>',
    $shareIcons
  );
}



// WEBPACK FOOTER //
// ./assets/src/js/components/article-detail.js